// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import * as labs from 'vuetify/labs/components';

// Vuetify
import { createVuetify } from 'vuetify';

// Custom theme properties
const customDarkTheme = {
  // dark: true,
  colors: {
    primary: '#CABDFF',
    secondary: '#FF6A55',
    'text-primary': '#6F767E',
    'text-secondary': '#FFFFFF',

    // 'background-primary': '#101213',
    'background-primary': '#0F1113',
    'background-secondary': '#1B1D1F',
    'background-tertiary': '#2D3138',

    error: '#f44336',
    info: '#2196F3',
    success: '#34BA96',
    warning: '#fb8c00',
  },
};

const customLightTheme = {
  colors: {
    primary: '#232D3F',
    secondary: '#18161E',
    'text-primary': '#232D3F',

    // 'background-primary': '#101213',
    'background-primary': '#EEF0F2',

    error: '#f44336',
    info: '#2196F3',
    success: '#34BA96',
    warning: '#fb8c00',
  },
};

// Set config defaults when creating the instance
export default createVuetify({
  theme: {
    defaultTheme: 'customLightTheme',
    themes: {
      customDarkTheme,
      customLightTheme,
    },
  },
  components: {
    ...labs,
  },
});
